export default "<p>\r\n  administracion-causales-no-entrega works!\r\n</p>\r\n"